export default {
  AFTER_SERVICE: 'afterService',
  BANNED: 'banned',
  DND: 'dnd',
  IN_SERVICE: 'inService',
  INCOMING: 'incoming',
  OFFLINE: 'offline',
  ONLINE: 'online',
  OUTGOING: 'outgoing',
  READY: 'ready',
};
